export default "__VITE_ASSET__DBVeQRRG__"